import { useState, useRef, useEffect } from 'react'
import { Loader2 } from 'lucide-react'

export default function ExtractDialog({ archiveName, suggestedDest, onExtract, onClose }) {
  const [dest, setDest] = useState(suggestedDest)
  const [extracting, setExtracting] = useState(false)
  const ref = useRef(null)
  useEffect(() => { ref.current?.select() }, [])

  const confirm = async () => {
    if (!dest.trim() || extracting) return
    setExtracting(true)
    await onExtract(dest.trim())
    setExtracting(false)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl shadow-2xl p-5 w-96">
        <p className="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-1">Extract {archiveName}</p>
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">Choose where to extract the archive's contents.</p>
        <label className="text-[11px] font-medium text-gray-500 dark:text-gray-400 mb-1 block">Destination path</label>
        <input
          ref={ref}
          value={dest}
          onChange={(e) => setDest(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') confirm(); if (e.key === 'Escape') onClose() }}
          placeholder="/public_html/extracted"
          className="w-full bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl px-3 py-2 text-sm font-mono text-gray-900 dark:text-gray-100 outline-none focus:border-primary/50 focus:ring-2 focus:ring-primary/10 mb-4"
        />
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} disabled={extracting} className="px-3 py-1.5 rounded-xl text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors disabled:opacity-50">Cancel</button>
          <button
            type="button"
            onClick={confirm}
            disabled={!dest.trim() || extracting}
            className="flex items-center gap-2 px-4 py-1.5 rounded-xl bg-primary hover:bg-primary/90 disabled:opacity-40 text-white text-sm transition-colors"
          >
            {extracting && <Loader2 size={13} className="animate-spin" />}
            {extracting ? 'Extracting…' : 'Extract'}
          </button>
        </div>
      </div>
    </div>
  )
}
